(function () {
  'use strict';

  // ── Format "HH:MM" → "H:MMAM/PM" (matches store-locator card display) ──
  function fmt12(time24) {
    if (!time24) return '';
    const [h, m] = time24.split(':').map(Number);
    const period = h >= 12 ? 'PM' : 'AM';
    const h12    = h % 12 || 12;
    return `${h12}:${String(m).padStart(2, '0')}${period}`;
  }

  // ── Reformat raw 24h strings in hours table cells ───────────────────────
  function reformatHoursTable() {
    document.querySelectorAll('.store-page__hours-time[data-raw]').forEach(td => {
      const raw = td.dataset.raw || '';
      // Only reformat cells that contain two valid time values (open - close)
      const parts = raw.split(/[–-]/).map(s => s.trim());
      if (parts.length === 2 && parts[0] && parts[1]) {
        td.textContent = `${fmt12(parts[0])} - ${fmt12(parts[1])}`;
      }
    });
  }

  const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  function haversine(lat1, lng1, lat2, lng2) {
    const R    = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a    = Math.sin(dLat / 2) ** 2 +
                 Math.cos(lat1 * Math.PI / 180) *
                 Math.cos(lat2 * Math.PI / 180) *
                 Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  class StorePageMap extends HTMLElement {
    connectedCallback() {
      const lat = parseFloat(this.dataset.lat);
      const lng = parseFloat(this.dataset.lng);
      if (!lat || !lng) return;

      this._lat = lat;
      this._lng = lng;
      this._syncAddressPin();

      // Reformat hours table immediately (does not depend on Maps API)
      reformatHoursTable();
      this._loadMapsScript();
      this._tryGeolocation();
    }

    get _mapEl()       { return this.querySelector('.store-page__hero-map'); }
    get _distanceEl()  { return this.querySelector('.store-page__distance'); }
    get _addressPinEl() { return this.querySelector('[data-store-index-pin]'); }

    _getStoreIndex() {
      const params     = new URLSearchParams(window.location.search);
      const storeIndex = params.get('store_index');
      return storeIndex && !isNaN(storeIndex) ? storeIndex : '';
    }

    _syncAddressPin() {
      if (this._addressPinEl) this._addressPinEl.textContent = this._getStoreIndex();
    }

    _loadMapsScript() {
      if (window.google?.maps) {
        this._initMap();
        return;
      }
      window.initStorePageMap = () => this._initMap();
      const apiKey  = window.OCS?.mapsKey || '';
      const script  = document.createElement('script');
      const language = String(document.documentElement.lang || window.Shopify?.locale || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
      script.src    = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=${language}&region=CA&callback=initStorePageMap&loading=async`;
      script.async  = true;
      script.defer  = true;
      document.head.appendChild(script);
    }

    _initMap() {
      const center = { lat: this._lat, lng: this._lng };
      this._map    = new google.maps.Map(this._mapEl, {
        center,
        zoom:              16,
        mapTypeControl:    false,
        streetViewControl: false,
        fullscreenControl: false,
      });

      const pinUrl = this.dataset.pinUrl;
      const marker = new google.maps.Marker({
        position:  center,
        map:       this._map,
        title:     this.dataset.storeTitle || 'Store',
        optimized: false,
        icon: {
          url:         pinUrl,
          scaledSize:  new google.maps.Size(62, 62),
          origin:      new google.maps.Point(0, 0),
          anchor:      new google.maps.Point(31, 62),
          labelOrigin: new google.maps.Point(30.5, 23.8),
        },
      });

      // Show store_index from URL param on the pin
      const storeIndex = this._getStoreIndex();
      if (storeIndex) {
        marker.set('label', {
          text:          storeIndex,
          fontSize:      '12px',
          fontWeight:    '600',
          fontFamily:    'Calibre, Arial, sans-serif',
          letterSpacing: 'normal',
          fontStyle:     'normal',
        });
      }
    }

    _tryGeolocation() {
      if (!this._distanceEl) return;
      const params    = new URLSearchParams(window.location.search);
      const distParam = params.get('distance_km');
      const kmAway    = window.themeStrings?.kmAway || 'km away';

      if (distParam && !isNaN(distParam)) {
        this._distanceEl.textContent = `${parseFloat(distParam)}${kmAway}`;
        return;
      }

      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition((pos) => {
        const dist     = haversine(pos.coords.latitude, pos.coords.longitude, this._lat, this._lng);
        const distText = dist < 10 ? dist.toFixed(1) : Math.round(dist);
        this._distanceEl.textContent = `${distText}${kmAway}`;
      });
    }
  }

  customElements.define('store-page-map', StorePageMap);
}());
